import React from 'react'
import { OverflowMenuHorizontal32 } from '@carbon/icons-react'
import OverflowMenu, { OverflowMenuItem } from '../../../OverflowMenu'
import Select from '../../../Select'
import UbliqueColumn from '../Column'

import './index.scss'

const StripeChartMenu = ({ menuProps }) => {
  const renderMenuByType = (props, type) => {
    if (type === 'SELECT') {
      return (
        <Select onChange={props.onChange} noLabel value={props.selectedValue}>
          {props.menuItems.map(({ value, label }, index) => (
            <Select.Item
              key={index}
              value={value}
              text={label}
              id='select-item'
            />
          ))}
        </Select>
      )
    } else {
      return (
        <OverflowMenu
          flipped
          size={props.size || 'xl'}
          renderIcon={OverflowMenuHorizontal32}
        >
          {props.menuItems.map(({ id, text, onClick }, i) => (
            <OverflowMenuItem
              key={id || i}
              onClick={() => onClick(id || i)}
              itemText={text}
            />
          ))}
        </OverflowMenu>
      )
    }
  }
  return (
    <>
      {menuProps.chartTitle && (
        <UbliqueColumn className='stripe-menu-chart-title' sm={4} md={6} lg={8}>
          <h4>{menuProps.chartTitle}</h4>
        </UbliqueColumn>
      )}
      <UbliqueColumn
        sm={4}
        md={menuProps.chartTitle ? 2 : 8}
        lg={menuProps.chartTitle ? 4 : 12}
        className='stripe-menu-chart-menu'
      >
        {renderMenuByType(menuProps, menuProps.menuType)}
      </UbliqueColumn>
    </>
  )
}

export default StripeChartMenu
